var React = require('react');

function Seamless (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.2851 5.568L32.8649 12.9583L25.2851 20.3487L22.4927 17.4847L25.0838 14.9583H17.4112L25.2734 22.0764C27.9867 24.5329 26.2489 29.0417 22.5888 29.0417H14.9162L17.5073 31.568L14.7149 34.432L7.13508 27.0417L14.7149 19.6513L17.5073 22.5153L14.9162 25.0417H22.5888L14.7266 17.9236C12.0133 15.4671 13.7511 10.9583 17.4112 10.9583H25.0838L22.4927 8.432L25.2851 5.568Z","key":1})]);
}

Seamless.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = Seamless;

Seamless.default = Seamless;
